import React, { useState, useEffect } from 'react';
import { TopBar } from "../../shared/topBar/TopBar";
import { ToastContainer } from "react-toastify";
import { UrlPath } from '../../../config/routeConfig';
import { BreadCrumbs } from '../../shared/breadCrumbs/BreadCrumbs';
import { SBAComboBox } from '../../UiComponents/SBADropDown';
import { AgGridReact } from "ag-grid-react";
import { sbaAxios } from '../../utils/sbaAxios';
import { getClientStatementAPI, getPartnerShipDetails, getPartnership, getPartnershipPartner, getPartnershipPortfolio, insertNewPartnershipDetail, insertPartner, insertPartnership, updatePartnershipDetail } from '../../../config/apiConfig';
import { Modal } from "react-bootstrap";
import { SBNotify } from '../../utils/sbNotify';
import { SBADrawer } from '../../UiComponents/SBADrawer';
import { useDispatch, useSelector } from 'react-redux';
import { getTaxEntityListAction } from '../../actions/investorAccounts';
import { SBDatePicker } from '../../UiComponents/SBDatePicker';
import moment from 'moment';
import { getPercentageFormat } from '../../utils/conversionMethods';


export const Partnership = () => {
    const lastDate = new Date();
    lastDate.setDate(0);
    const removeDrawerTabIndex = () => {
        const drawers = document.getElementsByClassName('rs-drawer-wrapper');
        Array.from(drawers).forEach(drawer => {
            drawer.removeAttribute('tabIndex');
        });
    };
    removeDrawerTabIndex();
    const Level = [{ BreadCrumb: "Admin >", Routes: `${UrlPath.Admin}` },
    { BreadCrumb: "Partnerships > Partnership", Routes: `${UrlPath.Partnership}` }];
    useEffect(() => {
        document.title = "Partnership";
    }, []);
    const dispatch = useDispatch();
    const [partnershipList, setPartnershipList] = useState([]);
    const [selectedPartnership, setSelectedPartnership] = useState(null);
    const [partnersList, setPartnersList] = useState([]);
    const [selectedPartner, setSelectedPartner] = useState(null);

    const [addPartnerShip, setAddPartnerShip] = useState(false);
    const [partnerShipToAdd, setPartnerShipToAdd] = useState(null);
    const [portfolioToAdd, setPortfolioToAdd] = useState("");
    const [portfolioList, setPortfolioList] = useState([]);
    const [gridData,setGridData]=useState([]);

    const [clinetStatmentList, setClinetStatmentList] = useState([]);
    const [addPartner, setAddPartner] = useState(false);
    const [addPartnerPartnerShip, setAddPartnerPartnerShip] = useState(null);
    const [addPartnerShortName, setAddPartnerShortName] = useState("");
    const [addPartnerName, setAddPartnerName] = useState("");
    const [addPartnerCS, setAddPartnerCS] = useState(null);


    const [addPercentage, setAddPercentage] = useState(false);
    const [addPercentageAsOfDate,setAddPercentageAsOfDate] = useState(lastDate);
    const [addPercentageValue, setAddPercentageValue] = useState(0);
    const [edit,setEdit]=useState(false);
    const [editId,setEditId]=useState(0);


    const colDefs = [
        { headerName: 'Partner Name', field: 'PartnershipPartner' },
        { headerName: 'Short Name', field: 'PartnerShortName' },
        { headerName: 'As Of Date', field: 'AsOfDate' ,
        cellDataType: 'dateString',sortable: true,
        valueFormatter:(props)=>moment(props.value).format("MM/DD/YYYY")},
        { headerName: 'Partner Percentage', field: 'PartnershipValue', valueFormatter:(props)=>getPercentageFormat(props.value) },
        { headerName: 'Modified By', field: 'ModifiedBy' },
        { headerName: 'Modified Date', field: 'ModifiedDate',  valueFormatter:(props)=>moment(props.value).format("MM/DD/YYYY")},
        { headerName: '', field: '', maxWidth:100,  cellRenderer:(props)=><>
        <>  
        <i className="fas fa-edit" style={{ color:  "#47A547", cursor: "pointer" }} onClick={(e)=>{
            setEditId(props.data.PartnershipDetailId);
            setAddPercentageValue(props?.data?.PartnershipValue * 100);
            setEdit(true); 
            setAddPercentage(true);
            }}></i></>
        </>}
    ]


    useEffect(() => {
        getPartnershipList();
        // getPartnershipPart();
        getPartnerShipPortfolio();
        getClientStatement();

    }, []);

    const getPartnerShipPortfolio = () => {
        sbaAxios({ url: getPartnershipPortfolio }).then(res => {
            setPortfolioList(res)
        }).catch(err => {
            console.log(err);
            setPortfolioList([]);
        })
    }
    const getPartnershipList = () => {
        sbaAxios({ url: getPartnership }).then(res => {
            setPartnershipList(res)
        }).catch(err => {
            console.log(err);
            setPartnershipList([]);
        })
    }

    const getPartnershipPart = (partnerShipID) => {
        const url = partnerShipID > 0 ? getPartnershipPartner + "?partnershipId=" + partnerShipID : getPartnershipPartner;
        sbaAxios({ url }).then(res => {
            setPartnersList(res)
        }).catch(err => {
            console.log(err);
            setPartnersList([]);
        })
    }

    const getClientStatement = () => {
        sbaAxios({ url: getClientStatementAPI }).then(res => {
            setClinetStatmentList(res)
        }).catch(err => {
            console.log(err);
            setClinetStatmentList([]);
        })
    }



    const savePartnerShip = () => {
        if (!portfolioToAdd?.PortfolioId) {
            SBNotify({ Msg: "Please Select a Portfolio to Add", type: 'error' });
            return;
        }

        if (!partnerShipToAdd) {
            SBNotify({ Msg: "Please Enter the Parthnership Name", type: 'error' });
            return;

        }
        const dateIsoString = new Date().toISOString();
        const urrl = insertPartnership + "/" + portfolioToAdd.PortfolioId + "/" + partnerShipToAdd + "/" + dateIsoString
        sbaAxios({ url: urrl, method: "post" }).then(res => {
            if (res == -2) {
                SBNotify({ Msg: "PartnerShip Already Exist", type: 'error' });
            }
            else {
                SBNotify({ Msg: "PartnerShip Saved Successfully" });
                setPortfolioToAdd(null);
                setPartnerShipToAdd("");
                setAddPartnerShip(false);
                getPartnershipList();
            }
        }).catch(res => {
            console.log(res, 'Error Adding New PartnerShip')
        })
    };
    const savePartnerShipPartner = () => {
        if (!addPartnerPartnerShip?.PartnershipId) {
            SBNotify({ Msg: "Please Select a Partnership to Add", type: 'error' });
            return;
        }

        if (!addPartnerName) {
            SBNotify({ Msg: "Please Enter the partner Name", type: 'error' });
            return;

        }
        if (!addPartnerShortName) {
            SBNotify({ Msg: " Please Enter the Short Name", type: 'error' });
            return;

        }
        // if (!addPartnerAccount?.TaxEntityId) {
        //     SBNotify({ Msg: "Please Select a Account", type: 'error' });
        //     return;

        // } 
        if (!addPartnerCS?.ClientStatementId) {
            SBNotify({ Msg: "Please Select a Client Statement", type: 'error' });
            return;

        }
        const dateIsoString = new Date().toISOString();
        const urrl = insertPartner + "/" + addPartnerPartnerShip.PartnershipId + "/" + addPartnerName + "/" + addPartnerShortName + "/" + addPartnerCS.ClientStatementId + "/" + dateIsoString
        sbaAxios({ url: urrl, method: "post" }).then(res => {
            if (res == -2) {
                SBNotify({ Msg: "Partner Already Exist", type: 'error' });
            }
            else {
                SBNotify({ Msg: "Partner Saved Successfully" });
                setAddPartner(false);
                setAddPartnerPartnerShip(null);
                setAddPartnerCS(null);
                setAddPartnerName("");
                setAddPartnerShortName("");
                setPartnersList([]);
                getPartnershipPart(addPartnerPartnerShip.PartnershipId);
                setSelectedPartnership(addPartnerPartnerShip);
            }
        }).catch(res => {
            console.log(res, 'Error Adding New Partner')
        })
    };
    const fetchPartnerDetails=(partnerId)=>{
        const url=getPartnerShipDetails+"?partnershipPartnerId="+partnerId
        sbaAxios({url}).then(res=>{
            setGridData(res);
        }).catch(error=>{console.log(error,"Error Fetching the Partner Details")})
    };
    const savePartnerPercentage=()=>{
        if(!selectedPartner.PartnershipPartnerId)
        {
            SBNotify({ Msg: "Please Select a Partner", type: 'error' });
            return;
        };
        if(!selectedPartner.PartnershipId)
        {
            SBNotify({ Msg: "Please Select a Partnership", type: 'error' });
            return;
        }
        if(!addPercentageValue || addPercentageValue==0)
        {
            SBNotify({ Msg: "Please Enter the percentage value", type: 'error' });
            return;
        }
        const percentageVal=addPercentageValue/100;
        if(!edit)
        {
        const url=insertNewPartnershipDetail+"/"+selectedPartner.PartnershipPartnerId+"/"+percentageVal+"/"+addPercentageAsOfDate.toISOString();
            sbaAxios({url,method:"post"}).then(res=>{
                if(res==-1)
                {
                    SBNotify({ Msg: "Partner Percentage Already Exist For the Selected Date and Selected Partner", type: 'error' });
                }
                else 
                {
                    SBNotify({ Msg: "Partner Percentage Added Succesfully"});
                    fetchPartnerDetails(selectedPartner.PartnershipPartnerId);
                    setAddPercentage(false);
                    setAddPercentageValue(null);
                    setAddPercentageAsOfDate(lastDate);
                    setEdit(false);
                    setEditId(0);
    
                }
            }).catch(error=>{console.log(error,"Error Fetching the Partner Details")})
        }
      
        else {
        const url=updatePartnershipDetail+"/"+editId+"/"+percentageVal;

            sbaAxios({url,method:"post"}).then(res=>{
           
                    SBNotify({ Msg: "Partner Percentage Updated Succesfully"});
                    fetchPartnerDetails(selectedPartner.PartnershipPartnerId);
                    setAddPercentage(false);
                    setAddPercentageValue(null);
                    setAddPercentageAsOfDate(lastDate);
                    setEdit(false);
                    setEditId(0);

                
            }).catch(error=>{console.log(error,"Error Fetching the Partner Details")})
        }
    }

    return (
        <>
            <TopBar label={"Partnership"} />
            <div className="mainContentData">
                <BreadCrumbs Levels={Level} />
                <div className="container-fluid p-4 ">
                    <div className='row'>
                        <div className='container-fluid d-flex flex-column'>
                            <div className='d-flex flex-row' style={{ gap: '10px' }}>
                                <div style={{ minWidth: "15%" }}>
                                    <label className="label">Partnerships</label>
                                    <div>
                                        <SBAComboBox
                                            className="w-100"
                                            data={partnershipList}
                                            textField={"PartnershipName"}
                                            valueField={"PartnershipId"}
                                            value={selectedPartnership}
                                            onChange={(e) => {
                                                if (e.value) {
                                                    getPartnershipPart(e.value.PartnershipId);
                                                    setSelectedPartnership(e.value);
                                                    setSelectedPartner(null);
                                                }
                                            }}
                                            popupSettings={{ className: "modalDD" }}
                                        ></SBAComboBox>
                                    </div>
                                </div>
                                <div style={{ marginTop: '20px' }}>
                                    <button
                                        type="submit"
                                        className="p-sm-btn"
                                        onClick={() => {
                                            setAddPartnerShip(true);
                                           
                                        }}
                                    >
                                        Add
                                    </button>
                                </div>
                            </div>
                            <div className='d-flex flex-row' style={{ gap: '10px' }}>
                                <div style={{ minWidth: "15%" }}>
                                    <label className="label">Partners</label>
                                    <div>
                                        <SBAComboBox
                                            className="w-100"
                                            data={partnersList}
                                            textField={"PartnershipPartner"}
                                            valueField={"PartnershipPartnerId"}
                                            value={selectedPartner}
                                            onChange={(e) => {
                                                if (e.value) {
                                                    setSelectedPartner(e.value);
                                                    fetchPartnerDetails(e.value.PartnershipPartnerId);
                                                }

                                            }
                                            }
                                            popupSettings={{ className: "modalDD" }}
                                        ></SBAComboBox>
                                    </div>
                                </div>
                                <div style={{ marginTop: '20px' }}>
                                    <button
                                        type="submit"
                                        className="p-sm-btn"
                                        onClick={() => {
                                            setAddPartner(true);
                                        }}
                                    >
                                        Add
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='container-fluid' style={{ paddingTop: 0, marginTop: '20px' }}>
                            <div className="h4">Partnership Details</div>
                            <div className='row d-flex justify-content-end' style={{ marginRight: '65px' }}>
                                <button
                                    type="submit"
                                    className="p-sm-btn"
                                    onClick={() => {
                                       setAddPercentage(true);
                                       setEdit(false);
                                       setEditId(0);
                                    }}
                                    style={{ width: '75px' }}
                                >
                                    Add
                                </button>
                            </div>
                            <div className='row w-100'>
                                <>
                                    <div
                                        className="row my-4"
                                        style={{ height: "700px", width: "100%" }}
                                    >
                                        <div className="row col-12 h-100">
                                            <div
                                                className="ag-theme-alpine"
                                                style={{ height: "100%", width: "100%", paddingTop: 0 }}
                                            >
                                                <AgGridReact
                                                    rowData={gridData}
                                                    columnDefs={colDefs}
                                                    defaultColDef={{ flex: 1, resizable: true, minWidth: 100 }}
                                                />
                                            </div>
                </div>
            </div>
        </>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <SBADrawer title="Add New Partnership" setOpen={setAddPartnerShip} open={addPartnerShip}>

                <div>
                    <label class="form-label">Portfolio Name:</label>
                    <SBAComboBox textField={"PortfolioName"}
                        valueField={"PortfolioId"} data={portfolioList} value={portfolioToAdd} onChange={(e) => {
                            if (e.value) {
                                setPortfolioToAdd(e.value)
                            }
                        }} popupSettings={{ className: "modalDD" }} />

                </div>
                <div className='my-2'>
                    <label class="form-label">Partnership Name:</label>
                    <input type='text'
                        className="form-control me-3"
                        placeholder="Enter new name" value={partnerShipToAdd} onChange={(e) => {
                            if (true) {
                                setPartnerShipToAdd(e.target.value);
                            }
                        }} />
                </div>

                <button className="s-sm-btn mx-1" onClick={() => {
                    setPortfolioToAdd(null);
                    setPartnerShipToAdd("");
                    setAddPartnerShip(false);
                }}>
                    Cancel
                </button>
                <button
                    className="p-sm-btn mx-1"
                    onClick={() => { savePartnerShip() }}
                >
                    Save
                </button>
            </SBADrawer>

            <SBADrawer title="Add New Partnership Partner" setOpen={setAddPartner} open={addPartner}>
                <div>
                    <label class="form-label">Partnership:</label>
                    <SBAComboBox
                        textField={"PartnershipName"}
                        valueField={"PartnershipId"}
                        data={partnershipList}
                        value={addPartnerPartnerShip}
                        onChange={(e) => {
                            if (e.value) { setAddPartnerPartnerShip(e.value) }
                        }}
                        popupSettings={{ className: "modalDD" }}
                    />

                </div>
                <div className='my-2'>
                    <label class="form-label">Partner Name:</label>
                    <input type='text'
                        className="form-control me-3"
                        placeholder="Enter new name" value={addPartnerName} onChange={(e) => {
                            if (true) { setAddPartnerName(e.target.value) }
                        }} />
                </div>

                <div className='my-2'>
                    <label class="form-label">Short Name:</label>
                    <input type='text'
                        className="form-control me-3"
                        placeholder="Enter new name" value={addPartnerShortName} onChange={(e) => { setAddPartnerShortName(e.target.value) }} />
                </div>

                {/* <div className='my-2'>
                    <label class="form-label">Account:</label>
                    <SBAComboBox 
                        textField={"TaxEntityName"}
                        valueField={"TaxEntityId"} 
                        data={accountList}
                        value={addPartnerAccount} 
                        onChange={(e) => { setAddPartnerAccount(e.value) }} 
                        popupSettings={{ className: "modalDD" }}
                    />
                </div> */}


                <div className='my-2'>
                    <label class="form-label">Client Statement:</label>
                    <SBAComboBox
                        textField={"ClientStatementName"}
                        valueField={"ClientStatementId"}
                        data={clinetStatmentList}
                        value={addPartnerCS}
                        onChange={(e) => {
                            if (e.value) { setAddPartnerCS(e.value) }
                        }}
                        popupSettings={{ className: "modalDD" }}
                    />
                </div>

                <button className="s-sm-btn mx-1" onClick={() => {
                    setAddPartner(false);
                    setAddPartnerPartnerShip(null);
                    setAddPartnerCS(null);
                    setAddPartnerName("");
                    setAddPartnerShortName("");
                }}>
                    Cancel
                </button>
                <button
                    className="p-sm-btn mx-1"
                    onClick={() => { savePartnerShipPartner() }}
                >
                    Save
                </button>
            </SBADrawer>


            <SBADrawer title= {!edit ? "Add Partner Percentage":"Edit Partner Percentage" } setOpen={setAddPercentage} open={addPercentage}>
                <div className='my-2'>
                    <label class="form-label">Partnership:</label>
                    <SBAComboBox
                        className="w-100"
                        data={partnershipList}
                        textField={"PartnershipName"}
                        valueField={"PartnershipId"}
                        value={selectedPartnership}
                        disabled={edit}
                        onChange={(e) => {
                            if (e.value) {
                                getPartnershipPart(e.value.PartnershipId);
                                setSelectedPartnership(e.value);
                                setSelectedPartner(null);
                            }
                        }}
                        popupSettings={{ className: "modalDD" }}
                    ></SBAComboBox>
                </div>

                <div className='my-2'>
                    <label class="form-label">Partner:</label>
                    <SBAComboBox
                        className="w-100"
                        data={partnersList}
                        textField={"PartnershipPartner"}
                        valueField={"PartnershipPartnerId"}
                        value={selectedPartner}
                        disabled={edit}
                        onChange={(e) => {
                            if (e.value) {
                                fetchPartnerDetails(e.value.PartnershipPartnerId)
                                setSelectedPartner(e.value);
                            }
                        }
                        }
                        popupSettings={{ className: "modalDD" }}
                    ></SBAComboBox>
                </div>
                <div className='my-2'>
                    <label class="form-label">As of Date:</label>
                    <div className='d-block'>
                    <SBDatePicker 
                        disabled={edit}
                    value={moment(addPercentageAsOfDate)} onChange={(e)=>{setAddPercentageAsOfDate(e)}}></SBDatePicker>
                    </div>
                </div>
                <div className='my-2'>
                    <label class="form-label">Percentage:</label>
                    <input type='number' className='form-control' value={addPercentageValue} onChange={(e)=>{setAddPercentageValue(e.target.value)}}/>
                </div>
                <button className="s-sm-btn mx-1" onClick={() => {
                  setAddPercentage(false);
                  setAddPercentageValue(null);
                  setAddPercentageAsOfDate(lastDate);
                  setEdit(false);
                  setEditId(0);
                }}>
                    Cancel
                </button>
                <button
                    className="p-sm-btn mx-1"
                    onClick={() => { savePartnerPercentage() }}
                >
                    Save
                </button>
            </SBADrawer>

            <ToastContainer />
        </>
    );
};
